import { useEffect } from "react";
import useWakeLock from "./WakeLock";
import { useAppSelector } from "../../redux";

const WakeLockManager = () => {
  const { enableWakeLock, disableWakeLock } = useWakeLock();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (isAuthenticated) {
      enableWakeLock().catch(() => {});
    } else {
      disableWakeLock().catch(() => {});
    }
  }, [isAuthenticated, enableWakeLock, disableWakeLock]);

  return null;
};

export default WakeLockManager;